let urlApi = process.env.REACT_APP_BACKEND_URL;
const imageCDN = process.env.REACT_APP_IMAGE_FOLDER;
let Fanpage = process.env.REACT_APP_FAN_PAGE_URL;
let Group = process.env.REACT_APP_GROUP;
let SUPPORT = process.env.REACT_APP_SUPPORT_URL;
let chat = process.env.REACT_APP_CHAT_URL;
const napthe = "https://trikytrungphung.net/news/:id15";
export const Path = {
  urlApi,
  Fanpage,
  Group,
  imageCDN,
  napthe,
  SUPPORT,
  chat,
};
